module.exports = __webpack_public_path__ + "img/Pelletsverbrauch.f0c7e75.png";